import Text from "@components/Text";
import Accordion from "@components/_Revamp/Accordion";
import Bullet from "@components/_Revamp/Bullet";
import Button from "@components/_Revamp/Button";
import Listing from "@components/_Revamp/Listing";
import {
  NotificationBox,
  NotificationContent,
} from "@components/_Revamp/NotificationBox";
import {
  RadioButton,
  RadioButtonGroup,
} from "@components/_Revamp/RadioButton/RadioButton";
import { SliderInput } from "@components/_Revamp/SliderInput/SliderInput";
import Stepper from "@components/_Revamp/Stepper";
import { Tooltip } from "@components/_Revamp/Tooltip/Tooltip";
import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import {
  CoverageAttribute,
  Coverages,
  CoveragesAdlPayload,
  LifeProfile,
  SQSPocketRequest,
  SQSPocketResponse,
} from "@models/MLTC/SQSPocketRequest.model";
import { CoverageForm } from "@models/MLTC_R3/Coverage.model";
import { useAvivaSelector } from "@redux/hook";
import {
  confirmQuotation,
  updateCoverageTerm,
  updateMonthlyBenefitsAmountSelection,
  updatePercentage,
  updatePlanOverview,
  updatePlanSelection,
  updateQuoteRequest,
  updateQuoteResponse,
  updateSQSQuotation,
  updatePlanDetails,
  updateTransactionId,
  updateGIONRICDetails,
  updateGIODeclaration,
  updateCSTOPUPCampaignValidity,
  setHasHydratedMonthlyBenefit,
} from "@redux/slices/MLTC_R3/step2Slice";
import { Helpers } from "@utils/helpers";
import useForm from "@utils/useForm";
import { debounce, find, get, isEmpty, isNumber, set } from "lodash";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { themeDefault } from "src/theme-revamp";
import { scrollToRef } from "../../../utils/scrollScript";
import { validate } from "./service";
import { postCheckEligibityForCampaign, postComputePremium } from "@api/index";
import { GAAviva, MLTC_R3_JOURNEY_NAME } from "@utils/gaAvivaR3";
import PromoCodeModal from "./components/PromoCodeModal";
import PromoCodeContent from "./components/PromoCodeContent";
import { updateCoverage } from "@redux/slices/MLTC_R3/step1Slice";
import { Step } from "@components/_Revamp/Stepper/Stepper";
import BottomSheetDrag from "@components/_Revamp/BottomSheetDrag";
import { TooltipBottomSheet } from "@components/_Revamp/TooltipBottomSheet/TooltipBottomSheet";
import BottomSheet from "@components/_Revamp/BottomSheet";
import { EzSaleRequest } from "@models/EzSaleRequest.model";
import CardList from "./components/CardList";
import infoIcon from "@assets/icon/info-gray-solid.svg";
import infoNoteIcon from "@assets/icon/info-black.svg";
import promoDiscountIcon from "@assets/icon/promo-discount-icon.svg";
import promoDiscountAppliedIcon from "@assets/icon/promo-discount-applied-icon.svg";
import UnderwritingAppliedIcon from "@assets/icon/underwriting-applied-icon.svg";
import campaignIcon from "@assets/icon/underwriting-campaign-icon.svg";
import warningIcon from "@assets/icon/info-yellow.svg";
import successTickIcon from "@assets/icon/round-tick-success.svg";
import InfoErrorIcon from "@assets/icon/info-error.svg";
import { DEFAULT_DISCLAIMER_MSG, DISCLAIMER_TEXT } from "@static/content";
import {
  CSTOPUP_TERMS_AND_CONDITIONS,
  EBLTC_TERMS_AND_CONDITIONS,
  MLTC_DISCLAIMER_MIN_ANNUAL_PREMIUM,
  QR_LTC_MAX_COVERAGE_LINK,
} from "@static/staticConstents";
import AlertNotification from "@components/_Revamp/AlertNotification";
import alertGreen from "@assets/icon/alert-green-tick.svg";
import dollarIconImg from "@assets/icon/dollar-circle-icon.svg";
import Input from "@components/_Revamp/Input";
import RadioInput from "@components/_Revamp/RadioInput";
import Spinner from "@components/_Revamp/Spinner";
import Icon from "@components/_Revamp/Icon";
import Typography from "@components/_Revamp/Typography";
import Link from "@components/_Revamp/Link";
import { updateQRLTCDiscountDescription } from "@redux/slices/MLTC_R3/step5Slice";
import QRLTCMaxCoverageModal from "./components/QRLTCMaxCoverageModal";

const PlanTermTooltipListing = styled.ul`
  display: flex;
  flex-direction: column;
  padding-left: 0px;
`;

const PlanTermTooltipContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  @media screen and (max-width: 768px) {
    row-gap: 16px;
  }
`;

const PayoutTooltipContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  @media screen and (max-width: 768px) {
    row-gap: 16px;
  }
`;

const TootipListingItem = styled.li`
  margin-left: 22px;
  position: relative;
  &:before {
    content: "";
    position: absolute;
    top: 13px;
    left: -13px;
    width: 2px;
    height: 2px;
    border-radius: 100rem;
    background-color: #434343;
  }
`;

const ADLCoverageTooltipDescription = styled.p`
  color: #434343;
  font-size: 14px;
  line-height: 1.8;
`;

const ADLCoverageTooltipContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  @media screen and (max-width: 768px) {
    row-gap: 16px;
  }
`;

const Container = styled.div`
  position: relative;
  // padding: 0 100px;
  margin: 0 auto;
  max-width: 1230px;
  display: block;
  flex-wrap: wrap;
  margin-top: 220px;

  @media screen and (max-width: 768px) {
    /* padding: 0 12px; */
    padding: 0 24px;
  }
`;

const ModalContainer = styled.div`
  position: fixed;
  display: none;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100;
  overflow-x: hidden;
  background-color: rgba(51, 51, 51, 0.85);
  pointer-events: none;
  opacity: 0;
  transition: opacity 500ms ease;
  box-shadow: none;
  @media screen and (min-width: 768px) {
    display: block;
  }
`;

const MobileModalContainer = styled.div`
  display: block;
  @media screen and (min-width: 768px) {
    display: none;
  }
`;

const AccordionContainer = styled.div`
  margin-top: 120px;
  padding-bottom: 50px;
  @media screen and (max-width: 768px) {
    margin-top: 40px;
    padding-bottom: 100px;
  }
`;

const FormContainer = styled.div<FormHeaderContainerProps>`
  /* max-width: 327px; */
  /* opacity: 0; */
  -webkit-transition: opacity 0.5s ease-in;
  -moz-transition: opacity 0.5s ease-in;
  -o-transition: opacity 0.5s ease-in;
  -ms-transition: opacity 0.5s ease-in;
  transition: opacity 0.5s ease-in;
  transition: all 0.2s ease;
  flex-direction: column;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  /* margin: ${(props) =>
    props.margin ? props.margin : "200px auto 0px auto"}; */
  margin: 0 auto 48px;
  /* padding: 0 24px; */
  @media screen and (min-width: 768px) {
    max-width: ${(props) => (props.maxWidth ? props.maxWidth : "unset")};
    margin: ${(props) => (props.margin ? props.margin : "150px auto 0 auto")};
    padding: 0;
  }
  @media screen and (min-width: 1024px) {
    max-width: ${(props) => (props.maxWidth ? props.maxWidth : "unset")};
    /* padding:0 195px; */
  }
  @media screen and (min-width: 1250px) {
    /* margin: ${(props) =>
      props.margin ? props.margin : "150px auto 0 auto"}; */
  }
`;

const QuoteButtonContainer = styled.div`
  margin-top: 64px;
  display: flex;
  justify-content: center;
  margin-bottom: 100px;
  @media screen and (max-width: 768px) {
    margin-top: 48px;
  }
`;

const QuoteContainer = styled.div`
  margin-top: 64px;
  display: block;
  @media screen and (max-width: 768px) {
    margin-top: 34px;
  }

  a {
    font-size: 12px;
  }
`;

const QuoteListingContainer = styled.div`
  margin-top: 64px;
  display: block;
  @media screen and (max-width: 768px) {
    margin-top: 48px;
  }
`;

const FormContentContainer = styled.div<FormHeaderContainerProps>`
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "unset")};
  margin: ${(props) => (props.margin ? props.margin : "0 20px;")};
  width: 100%;
  display: block;
  /* padding-bottom: 30px; */
  @media screen and (max-width: 768px) {
  }
`;

const FormHeaderContainer = styled.div<FormHeaderContainerProps>`
  display: block;
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "unset")};
  margin: ${(props) => (props.margin ? props.margin : "unset")};
  /* margin-bottom:24px; */
  @media screen and (min-width: 768px) {
    /* margin-bottom:64px; */
  }
`;

const FormHeaderTitleContainer = styled.div<FormHeaderTitleContainerProps>`
  display: flex;
  margin-bottom: 4px;
  @media screen and (min-width: 768px) {
    margin: 0 ${(props) => props.marginHorizontal} 4px;
  }
`;

const LeftBorder = styled.div`
  background-color: #883e89;
  width: 6px;
  border-radius: 4px;
  margin-right: 16px;
  flex-shrink: 0;
`;

const FormHeaderDescriptionContainer = styled.div`
  display: block;
  margin: 0;
  padding: 0;
  margin-left: 22px;
`;

const HeaderContainer = styled.div`
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

const notificationHeading = css`
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: #1e1e1e;
  display: flex;
  margin-top: 2rem;
  background-color: #f4f6f9;
  padding: 0.75rem 1.5rem;
  border-radius: 1rem;
  box-shadow: 0px 9px 9px rgba(0, 0, 0, 0.09), 0px 36px 14px rgba(0, 0, 0, 0.01);
  span.purple {
    font-weight: 600;
    color: #883e89;
    margin-left: 8px;
  }
  span.black {
    font-weight: 600;
    color: #1e1e1e;
  }
`;

const IconElement = styled.img`
  width: 20px;
  height: 20px;
  object-fit: contain;
  position: relative;
  top: 3px;
`;

const HeaderTitleCss = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 140%;
  color: #434343;
  @media screen and (min-width: 768px) {
    font-size: 28px;
  }
`;

const HeaderMonthlyBenefitTitleCss = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 140%;
  color: #000000;
  @media screen and (min-width: 768px) {
    font-size: 18px;
  }
`;

const QuoteListingTitleCss = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 140%;
  text-align: center;
  color: #b474b0;
  margin-bottom: 20px;
  @media screen and (max-width: 768px) {
    margin-bottom: 16px;
  }
`;

const HeaderDescriptionCss = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  text-align: left;
  color: #8a8988;
`;

const NRICDescriptionCss = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  text-align: left;
  color: #8a8988;
`;

const nricEligibilityCss = css`
  font-weight: 400;
  font-size: 14px;
  color: #434343;
`;

const ErrorMessage = styled.div`
  display: flex;
  column-gap: 15px;
  align-items: flex-start;
  padding: 0 0 24px 0;
  margin-top: 1rem;
  @media screen and (min-width: 768px) {
    padding: 0;
  }
`;

const container_default_css = css`
  margin-bottom: 0px;
`;

const title_default_css = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  @media screen and (max-width: 768px) {
    width: unset;
    font-size: 16px;
  }
`;

const AccordionParagraph = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 25.2px;
  color: #434343;
`;

const headingText = css`
  flex: 3;
  width: 100%;
  @media screen and (max-width: 768px) {
    margin-bottom: 24px;
  }
`;

const successNRICBannerInfo = css`
  color: #005348;
  font-weight: 600;
  font-size: 12px;
`;

const termsCss = css`
  font-weight: 400;
  font-size: 14px;
  color: #434343;
`;

const linkCss = css`
  font-weight: 600;
  font-size: 1rem;
  color: #883e89;
  text-decoration: underline;
  cursor: pointer;
`;

const termsHeadingCss = css`
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #883e89;

  img {
    margin-right: 0.5rem;
  }
`;

const termsModalContainer = css`
  color: #434343;
  padding: 2.5rem;
  .modal-body {
    border-radius: 1rem;
  }
`;

const underwritingCss = css`
  font-size: 12px;
  font-weight: 400;
  font-family: "Open Sans";
  color: #8a8988;
  margin-top: 1.5rem;
`;

const noteNRICBannerInfo = css`
  font-weight: 600;
  color: #434343;
  font-size: 12px;
`;
const noteCss = css`
  margin: 1rem 0;
  font-weight: 400;
  font-size: 12px;
  color: #8a8988;
  font-family: "Open Sans";

  span {
    color: #883e89;
    text-decoration: underline;
    cursor: pointer;
    font-weight: 600;
  }
`;

const noteAppliedCss = css`
  font-weight: 600;
  font-size: 12px;
  color: #0a544f;
  display: flex;
`;

const noteErrorCss = css`
  font-weight: 600;
  font-size: 12px;
  color: #990005;
  display: flex;
`;

const appliedLabelCss = css`
  border: 1px solid #0a544f;
  padding: 0.25rem 0.5rem;
  border-radius: 0.5rem;
  background-color: #eefdfc;
  display: flex;

  span {
    color: #0a544f;
    font-size: 12px;
    font-weight: 600;
    align-self: center;
  }

  @media screen and (max-width: 768px) {
    width: max-content;
    margin: 1rem 0;
  }
`;

const campaignCriteriaAppliedSectionCss = css`
  background-color: #eefdfc;
  border-radius: 1rem;
  padding: 1.5rem;
  margin-top: 1.5rem;
`;
const termsAppliedSectionCss = css`
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: 768px) {
    display: block;
  }
`;

const termsAppliedHeadingCss = css`
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #0a544f;

  img {
    margin-right: 0.5rem;
  }
`;
const termsAppliedCss = css`
  font-weight: 400;
  font-size: 14px;
  color: #434343;
`;

const campaignCriteriaSectionCss = css`
  background-color: #faf4f9;
  border-radius: 1rem;
  padding: 1.5rem;
  margin-top: 1.5rem;
`;

const noteSectionCss = css`
  color: #434343;
  font-size: 1rem;
  font-weight: 600;
  margin-top: 1rem;
`;

const CSTOPUPDiscountBanner = css`
  background-color: #fffce4;
  border-radius: 1rem;
  padding: 1rem;
  display: flex;
  gap: 0.5rem;
  margin: 1.5rem 0;
`;

const CSTOPUPDiscountBannerContent = css`
  font-size: 14px;
  font-weight: 400;
  color: #655b00;

  span {
    font-size: 14px;
    font-weight: 600;
  }
`;

const recommendedLabelCss = css`
  font-size: 12px;
  font-weight: 600;
  color: #883e89;
  margin-top: 1rem;
`;

const customModalCss = css`
  text-align: center;
  padding: 1.5rem;
  gap: 1.5rem;

  @media screen and (max-width: 768px) {
    padding: 0;
  }
`;

const imgCss = css`
  margin-top: 1.5rem;

  @media screen and (max-width: 768px) {
    margin-top: 0;
  }
`;

const buttonContainerCss = css`
  justify-content: center;
  display: flex;
  margin: 1.5rem 0;
`;

const maxModalTitle = css`
  color: #434343;
  font-weight: 600;
  font-size: 18px;
  margin: 1rem 0;
`;
const maxModalDesc = css`
  color: #434343;
  font-weight: 400;
  font-size: 14px;
  margin: 0 1.5rem;
  padding: 0 1.5rem;

  @media screen and (max-width: 768px) {
    padding: 0;
    margin: 0;
  }
`;


export interface FormHeaderContainerProps {
  margin?: string;
  maxWidth?: string;
}

export interface StepInterface {
  label: string;
  isCurrentStep: boolean;
}

export interface FormHeaderTitleContainerProps {
  marginHorizontal: string;
  maxWidth?: string;
}

const toolTipData = [
  // "After you turn 68 or 98 years old, you'll pay premiums until your policy anniversary",
  // "If you're 49 years old or older when you start, you'll pay for 20 years from your entry age",
  "The premium term and premiums will remain the same as you age",
  "Premiums are calculated based on Age Next Birthday",
];

const ChoosePlan = () => {
  const dispatch = useDispatch();
  const basicDetails = useAvivaSelector(
    (state) => state.mltcR3Step1.basicDetails,
  );
  const gioNricDetails = useAvivaSelector(
    (state) => state.mltcR3Step2.gioNricDetails,
  );
  const gioDeclaration = useAvivaSelector(
    (state) => state.mltcR3Step2.gioDeclaration,
  );
  const initValue = useAvivaSelector((state) => state.mltcR3Step1.coverage);
  const planSelected = useAvivaSelector(
    (state) => state.mltcR3Step2.planSelection,
  );
  const campaignDetail = useAvivaSelector(
    (state) => state.loading.campaignDetail,
  );
  const age = basicDetails?.dob
    ? Helpers.getAge(
        new Date(
          `${basicDetails.dob.month}/${basicDetails.dob.day}/${basicDetails.dob.year}`,
        ),
      )
    : null;
  
  const isEBLTC = campaignDetail?.code === "EBLTC" && campaignDetail?.status !== "EXPIRED" && age !== null && (age >= 31 && age <= 40);
  const isCampaignEligible = useAvivaSelector(
    (state) => state.loading.campaignEligibility,
  );
  const isGIOEligible = useAvivaSelector(
    (state) => state.loading.isGIOEligible,
  );
  const isCSTopupEligible = useAvivaSelector(
    (state) => state.loading.isCSTopupEligible,
  );
  const resetQRData = useAvivaSelector(
    (state) => state.mltcR3Step5.resetQRData,
  );
  const [csTopupValid, setCsTopupValid] = useState(false);
  const [isValidNRICResponse, setIsValidNRICResponse] = useState(false);
  const [showNRICAlert, setShowNRICAlert] = useState(false);
  const [maxGIOMonthlyBenefit, setMaxGIOMonthlyBenefit] = useState(200);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [isUOB, setIsUOB] = useState<boolean>(false);
  const [genericError, setGenericError] = useState<string | undefined>(
    undefined,
  );
  const [planStructure, setPlanStructure] = useState<any>({});
  const [premiumTerm, setPremiumTerm] = useState<any>({});
  const [validNric, setValidNric] = useState<boolean>(false);
  const [requirePromoNric, setRequirePromoNric] = useState<boolean>(false);
  const [hasCheckNric, setHasCheckNric] = useState<boolean>(
    !isEmpty(initValue?.promoNric) || false,
  );
  const [isCalculated, setIsCalculated] = useState<boolean>(false);
  const [checkedPromoCode, setCheckedPromoCode] = useState<string>("");
  const [appliedPromoCode, setAppliedPromoCode] = useState<boolean>(false);
  const [promoCodeError, setPromoCodeError] = useState<string>("");
  const [promoCodeStatus, setPromoCodeStatus] = useState<string>("");
  const [promoMsgCodeStatus, setPromoMsgCodeStatus] = useState<string>("");
  const [nricMsgCodeStatus, setNricMsgCodeStatus] = useState<string>("");
  const [premium, setPremium] = useState<any>({});
  const [quotes, setQuotes] = useState<any>(quoteInitialSample);
  const [planOverview, setPlanOverview] = useState<any>(summarizationSources);
  const [planSummaryOverview, setPlanSummaryOverview] = useState<any>(
    summarizationSummarySources,
  );
  const history = useHistory();
  const analyticUrlParams = useAvivaSelector(
    (state) => state.urlAnalytic.param,
  );
  const [currentAge, setCurrentAge] = useState<number>(0);
  const [planSelection, setPlanSelection] = useState<number>(1);
  const [termSelection, setTermSelection] = useState<
    "limited" | "lifetime" | ""
  >("");
  const [monthlyBenefitsAmountSelection, setMonthlyBenefitsAmountSelection] =
    useState<number>(0);
  const [isQuoteBreakdown, setQuoteBreakdown] = useState<boolean>(false);
  const [isPromoCodeVisible, setIsPromoCodeVisible] = useState<boolean>(false);
  const [showQRLTCMaxCoverageModal, setShowQRLTCMaxCoverageModal] = useState<boolean>(false); 
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isCalculating, setCalculating] = useState<boolean>(false);
  const formQuoteRef = useRef<null | HTMLDivElement>(null);
  const modalContainerRef = useRef<null | HTMLDivElement>(null);
  const exclusiveOffersRef = useRef<HTMLDivElement | null>(null);
  const [scrollTrigger, setScrollTrigger] = useState(0);
  const bottomSheet1 = useRef<any>(null);
  const bottomSheet2 = useRef<any>(null);
  const isValidPromoCode = useAvivaSelector(
    (state) => state.mltcR3Step5.validPromoCode,
  );
  const encryptedPromoCode = useAvivaSelector(
    (state) => state.mltcR3Step5.promoCode,
  );
  const QRTermValue = useAvivaSelector((state) => state.mltcR3Step5.QRTerm);
  const QRMonthlyBenefitValue = useAvivaSelector(
    (state) => state.mltcR3Step5.QRMonthlyBenefit,
  );
  const monthlyBenefit = useAvivaSelector(
    (state) => state.mltcR3Step2.monthlyBenefitsAmountSelection,
  );

  const hasHydrated = useAvivaSelector(
    (state) => state.mltcR3Step2.hasHydratedMonthlyBenefit,
  );
  const qrClientDetails = useAvivaSelector(
    (state) => state.mltcR3Step5.qrClientDetails,
  );
  const validQRClient = qrClientDetails?.status === "SUCCESS";
  const clientQRData = validQRClient ? qrClientDetails?.clientMasterData : null;
  const planDetailsFromStore = useAvivaSelector(
      (state) => state.mltcR3Step2.planDetails
  );
  const paramsFromStore = useAvivaSelector((state) => state.urlAnalytic.param);
  const transactionId = useAvivaSelector(
    (state) => state.mltcR3Step2.transactionId,
  );
  const paramCC = campaignDetail?.campaignCode
    ? `?cc=${campaignDetail.campaignCode}`
    : "";
  const combineParamCC = campaignDetail?.campaignCode
    ? `&cc=${campaignDetail.campaignCode}`
    : "";
  const analyticParam = Helpers.getUrlAnalyticParams(
    paramCC !== "",
    analyticUrlParams,
  );
  const combineAnalyticParam = Helpers.getUrlAnalyticParams(
    true,
    analyticUrlParams,
  );
  const [aaTracking, setAATracking] = useState<string[]>([]);
  const [showDisclaimer, setShowDisclaimer] = useState<boolean>(true);
  const lastSqsResponse = useAvivaSelector(
    (state) => state.mltcR3Step2.quoteRawResponse,
  );
  const promoApplied =
    useAvivaSelector(
      (state) =>
        state?.mltcR3Step2?.sqsQuotation?.coverages[0]?.attributes
          ?.promoCodeSummary,
    ) || "";
  const sqsPromoCode =
    lastSqsResponse?.coverages[0]?.attributes?.promoCode || "";
  const disclaimerContentArray = [DEFAULT_DISCLAIMER_MSG];
  const rawAgentDetailResponse = useAvivaSelector(
    (state) => state.mltcR3Step5.agentDetailResponseRaw,
  );
  const stepsList: Step[] = [
    {
      label: "Basic Info",
      isCurrentStep: false,
      path: "/mltc/lets-get-started",
      disabled: validQRClient,
    },
    {
      label: "Quote",
      isCurrentStep: true,
      path: "/mltc/choose-plan",
    },
    {
      label: "Health Declaration",
      isCurrentStep: false,
      path: "/mltc/health",
    },
    {
      label: "Start Application",
      isCurrentStep: false,
      path: "/mltc/my-info",
    },
    {
      label: "Review & Payment",
      isCurrentStep: false,
      path: "/mltc/review",
    },
  ];
  // QB-AA-Tracking fix: maps each form name tracked on this page to its journey step.
  // choose_plan_term_form fires on mount (plan/term are pre-populated together on this
  // page) as step 3; monthly_benefit_form also fires on mount and is its own step 4;
  // quote_overview_form is the only one gated on user action - it only fires once the
  // customer clicks "Get my quote" (see the isQuoteBreakdown effect below) - so step 5
  // only triggers on that click, not on page load.
  const CHOOSE_PLAN_STEP_INFO: Record<string, { stepName: string; stepNumber: string }> = {
    mltc_choose_plan_term_form: { stepName: "Choose Plan and Term", stepNumber: "3" },
    mltc_monthly_benefit_form: { stepName: "Monthly Benefit", stepNumber: "4" },
    mltc_quote_overview_form: { stepName: "Quote", stepNumber: "5" },
  };

  const trackOnLoad = (formName: string, type: string): void => {
    if (!aaTracking.includes(formName)) {
      setAATracking([...aaTracking, formName]);

      const GA = GAAviva.getInstance();
      let { form, acquisition, cta, page } = GA.digitalData;
      form.name = formName;
      form.error.fieldLabels = [];
      form.error.messages = [];
      form.error.numErrors = "0";
      cta = {
        text: "",
        type: "",
      };
      acquisition.insurance.campaignCode = campaignDetail
        ? campaignDetail.campaignCode
        : "MLO1";

      if (type === "product") {
        acquisition.product.prodName =
          planOptions.options[planSelected === "MLTC" ? 0 : 1].description;
        acquisition.product.prodID = planSelected === "MLTC" ? "SCSS" : "SCSP"; //SCSS or SCSP
      } else if (type === "term") {
        acquisition.insurance.premiumTerm = (
          termSelection.toString() === "limited"
            ? (currentAge >= 49 ? 20 : 69 - currentAge).toString() + " years"
            : (99 - currentAge).toString() + " years"
        ).toString();
        acquisition.insurance.premiumType = termSelection.toString();
      } else if (type === "premium") {
        acquisition.insurance.premium = premium?.totalAnnualizedPremium;
      }

      const stepInfo = CHOOSE_PLAN_STEP_INFO[formName];
      page.journeyName = MLTC_R3_JOURNEY_NAME;
      page.stepName = stepInfo?.stepName || page.stepName;
      page.stepNumber = stepInfo?.stepNumber || page.stepNumber;

      GA.trackPageStart();
      GA.trackPageLoad({ form, acquisition, cta, page });
    }
  };

  const trackCTA = () => {
    const GA = GAAviva.getInstance();
    let { cta } = GA.digitalData;
    cta = {
      type: "MLTC Choose Plan Form",
      text: "View Quote Breakdown",
    };
    GA.trackCTAClick({ cta });
  };

  const sources = [
    {
      heading: {
        text: "Lump-sum Benefit",
        value: Helpers.toCurrencyND(monthlyBenefitsAmountSelection * 3),
        existingMonthlyBenefit: validQRClient
          ? Helpers.toCurrencyND(clientQRData?.existingMonthlyBenefit * 3)
          : "",
      },
      descriptions: [{ text: "3X of first monthly benefit payout" }],
    },
    {
      heading: {
        text: "Rehabilitation Benefit",
        basicPlanSelected: planSelected === 'MLTC',
        value: Helpers.toCurrencyND(monthlyBenefitsAmountSelection * 0.5),
        existingMonthlyBenefit: validQRClient ? Helpers.toCurrencyND(clientQRData?.existingMonthlyBenefit * 0.5) : "",
        eyaMonthlyBenefit: validQRClient ? Helpers.toCurrencyND(clientQRData?.eyaMonthlyBenefit * 0.5) : ""
      },
      descriptions: [{ text: "50% of monthly benefit payout" }],
      subDescriptions: [{ text: "(for Singlife Careshield Standard only)" }],
    },
    {
      heading: {
        text: "Add-on Benefit",
        value: Helpers.toCurrencyND(monthlyBenefitsAmountSelection),
        existingMonthlyBenefit: validQRClient
          ? Helpers.toCurrencyND(clientQRData?.existingMonthlyBenefit)
          : "",
      },
      descriptions: [
        { text: "100% of monthly benefit payout for up to 12 months" },
      ],
    },
    {
      heading: {
        text: "Caregiver Relief Benefit",
        value: Helpers.toCurrencyND(monthlyBenefitsAmountSelection * 0.6),
        existingMonthlyBenefit: validQRClient
          ? Helpers.toCurrencyND(clientQRData?.existingMonthlyBenefit * 0.6)
          : "",
      },
      descriptions: [
        { text: "60% of monthly benefit payout for up to 12 months" },
      ],
    },
    {
      heading: {
        text: "Dependant Care Benefit",
        value: Helpers.toCurrencyND(monthlyBenefitsAmountSelection * 0.2),
        existingMonthlyBenefit: validQRClient
          ? Helpers.toCurrencyND(clientQRData?.existingMonthlyBenefit * 0.2)
          : "",
      },
      descriptions: [
        { text: "20% of monthly benefit payout for up to 36 months" },
      ],
    },
    {
      heading: {
        text: "Death Benefit",
        value: Helpers.toCurrencyND(monthlyBenefitsAmountSelection * 3),
        existingMonthlyBenefit: validQRClient
          ? Helpers.toCurrencyND(clientQRData?.existingMonthlyBenefit * 3)
          : "",
      },
      descriptions: [{ text: "3X of last monthly benefit payout" }],
    },
  ];

  const accordionArgs = {
    title: "A few points to note before buying",
    theme: themeDefault,
    className: container_default_css,
    titleClassName: title_default_css,
    titleFontSize: 16,
    isExpanded: true,
    showBottomLine: true,
    showHeaderLine: true,
    bottomLineColor: "#c4c4c4",
    bottomLineThickness: "1px",
    contentMarginLeft: "0px",
    contentMarginRight: "0px",
    bottomLineClassName: "margin:10px",
  };

  const createSQSPayload = ({
    basicDetails,
    coverage,
    promoCodeSummary,
    campaignCode,
    nricValue,
  }: any): SQSPocketRequest => {
    let transaction_id;
    if (!transactionId) {
      transaction_id = crypto.randomUUID();
      dispatch(updateTransactionId(transaction_id));
    } else {
      transaction_id = transactionId;
    }
    const { day, month, year } = basicDetails.dob;
    const stringDate = `${month}/${day}/${year}`;
    const age = Helpers.getAge(new Date(stringDate));
    const lifeProfile = new LifeProfile({
      ...basicDetails,
      dob: `${day}${month}${year}`,
      age,
    });
    const { promoCode, monthlyBenefit, plan, ...orders } = coverage;

    const effectiveMonthlyBenefit = validQRClient
      ? Number(monthlyBenefit) - clientQRData?.existingMonthlyBenefit
      : isValidNRICResponse && gioDeclaration === "GIO" && maxGIOMonthlyBenefit
      ? Math.max(200, Math.min(Number(monthlyBenefit), maxGIOMonthlyBenefit))
      : Math.max(200, Number(monthlyBenefit));

    const attributePlan = new CoverageAttribute({
      ...orders,
      monthlyBenefit: effectiveMonthlyBenefit,
      promoCodeSummary:
        isValidPromoCode === "Y" ? encryptedPromoCode : promoCode.toUpperCase(),
      campaignCode,
    });
    const coveragePlan = new Coverages({
      id: planOptions.options[plan === "MLTC" ? 0 : 1].key,
      type: "P",
      attributes: attributePlan,
    });
    const coverageAdl = new CoveragesAdlPayload({
      id: plan === "MLTC" ? "twoADLAddOn" : "oneADLAddOn",
      type: "R",
      attributes: {},
    });
    return new SQSPocketRequest({
      encryptedPromoCode: isValidPromoCode === "Y" ? true : false,
      agentCode: isValidPromoCode === "Y" ? paramsFromStore.arc : "",
      transaction_id,
      ...(nricValue
        ? {
            campaigns: [
              ...(isGIOEligible ? [{ code: "GIO", nric: nricValue }] : []),
              ...(isCSTopupEligible
                ? [{ code: "CSTOPUP", nric: nricValue }]
                : []),
            ],
          }
        : {}),
      lifeprofiles: [lifeProfile],
      coverages: [coveragePlan, coverageAdl],
    });
  };

  const displayModal = (
    content: number,
    xCoord: number,
    yCoord: number,
    type: string = "",
  ) => {
    //When modal visible, body style set overflowY hidden to prevent scrolling
    // document.body.style.overflowY = "hidden";

    if (type === "click") {
      if (bottomSheet1 && bottomSheet2) {
        if (content === 1) bottomSheet1.current.open();
        else if (content === 2) bottomSheet2.current.open();
      }
    } else {
      let childrens = modalContainerRef.current
        ?.children as HTMLCollectionOf<HTMLElement>;

      if (childrens.length > 0) {
        childrens[content - 1].style.opacity = "1";
        childrens[content - 1].style.left = (xCoord - 70).toString() + "px";
        childrens[content - 1].style.top = yCoord.toString() + "px";
      }

      if (modalContainerRef && modalContainerRef.current) {
        modalContainerRef.current.style.opacity = "1";
      }
    }
  };

  const hideModal = (content: number, type: string = "") => {
    //When modal hide, body style set overflowY unset to allow scrolling of content
    document.body.style.overflowY = "unset";

    if (type === "click") {
      if (bottomSheet1 && bottomSheet2) {
        if (content === 1) bottomSheet1.current.close();
        else if (content === 2) bottomSheet2.current.close();
      }
    } else {
      if (modalContainerRef && modalContainerRef.current) {
        modalContainerRef.current.style.opacity = "0";
      }

      let childrens = modalContainerRef.current
        ?.children as HTMLCollectionOf<HTMLElement>;
      if (childrens.length > 0) {
        childrens[content - 1].style.opacity = "0";
      }
    }
  };

  const urlParams: URLSearchParams = Helpers.getURLSearchParams();

  const { handleChange, values, errors, formValid, patchValue } = useForm(
    new CoverageForm(initValue),
    () => {},
    validate,
  );

  const getGenericError = useCallback(() => {
    const nricError = urlParams.get("nricerror");

    if (nricError === "true") {
      setGenericError("Please enter NRIC number that matches with Myinfo");
    }
  }, [urlParams]);

  useEffect(() => {
    if (validQRClient && genericError) {
      dispatch(updateGIONRICDetails(""));
    }
  }, [validQRClient, genericError, dispatch]);

  useEffect(() => {
    handleChange({ target: { name: "plan", value: planSelected } });
  }, [premium]);

  useEffect(() => {
    getGenericError();
    //TODO: GET PARAMETERS FROM STEP 1
    if (campaignDetail && campaignDetail?.code === "LUB1") {
      setIsUOB(true);
    }
    if (!basicDetails) {
      onBack();
      return;
    }

    if (!isEmpty(initValue) && !isLoaded) {
      const nextValues = {
        ...values,
        plan: planSelected,
      };
      dispatch(updateCoverage(new CoverageForm(nextValues)));
      setIsLoaded(true);

      const { day, month, year } = basicDetails.dob;
      const stringDate = `${month}/${day}/${year}`;
      const age = Helpers.getAge(new Date(stringDate));
      setCurrentAge(age);
    }

    trackOnLoad("mltc_choose_plan_term_form", "product");
    trackOnLoad("mltc_monthly_benefit_form", "term");
  }, [isLoaded]);
  
  useEffect(() => {
    if (!premiumTerm?.value && !planStructure?.value) return;
    if (!premiumTerm?.terms || premiumTerm?.terms === "0") return;

    dispatch(
      updatePlanDetails({
        planStructure: planStructure?.value,
        planStructureDesc: planStructure?.description,
        premiumTerm: premiumTerm?.terms,
        premiumTermOption: premiumTerm?.value,
        premiumTermDesc: premiumTerm?.description,
        planName: values["plan"],
      }),
    );
  }, [planStructure, premiumTerm, values["plan"]]);

  

  useEffect(() => {
    if (!planDetailsFromStore || !currentAge) return;

    if (planDetailsFromStore.planStructure) {
      const ps = planStructureOptions.options.find(
        (o) => o.value === planDetailsFromStore.planStructure,
      );
      if (ps) setPlanStructure(ps);
    }

    if (planDetailsFromStore.premiumTermOption) {
      const pt = premiumTermOptions.options.find(
        (o) => o.value === planDetailsFromStore.premiumTermOption,
      );
      if (pt) setPremiumTerm(pt);
    }
  }, [planDetailsFromStore, currentAge]);

  useEffect(() => {
    if (!currentAge) return;

    // ✅ RESET UI selection
    setTermSelection("");
    setPremiumTerm({});

    handleChange({
      target: { name: "premiumTerm", value: "" },
    });

    // ✅ also clear quote
    dispatch(updateCoverageTerm(""));
    resetQuoteListing();
  }, [currentAge]);

  useEffect(() => {
    setTimeout(() => {
      if (formQuoteRef && formQuoteRef.current) {
        const elementOffSetTop = formQuoteRef.current.offsetTop;
        const top = window.pageYOffset || document.documentElement.scrollTop;
        scrollToRef(
          document.documentElement,
          "scrollTop",
          "",
          top,
          elementOffSetTop,
          300,
          true,
        );
        formQuoteRef.current.style.opacity = "1";
        trackOnLoad("mltc_quote_overview_form", "premium");
      }
    }, 100);
  }, [isQuoteBreakdown]);

  const additionalNricChecks = useCallback(
    async (nric: string, promoCode: string) => {
      const payload = new EzSaleRequest({ nric, campaignCode: promoCode });
      try {
        const response = await postCheckEligibityForCampaign(payload);
        /**MOCK */
        // const clientFound = false;
        const clientFound = get(response, "data.data.clientFound", false);
        const validPeriod = get(response, "data.data.validPeriod", false);
        setHasCheckNric(true);

        // if not clientFound and validPeriod
        if (clientFound && validPeriod) {
          const basicTarget = find(quotes, { type: "basic" });
          set(basicTarget, "details[6].value", promoCode);
          setQuotes([...quotes]);

          //dispatch(updatePromoNric(nric));
          const nextValues = {
            ...values,
            promoCode,
            promoNric: nric,
          };
          dispatch(updateCoverage(new CoverageForm(nextValues)));
          setValidNric(true);
          setAppliedPromoCode(true);
          setPromoCodeStatus("success");
          setPromoMsgCodeStatus("success");
          setNricMsgCodeStatus("");
          setTimeout(() => {
            setPromoCodeStatus("");
          }, 2000);
          return true;
        } else {
          setAppliedPromoCode(false);
          setValidNric(false);
          setPromoCodeStatus("invalidNric");
          setPromoMsgCodeStatus("");
          setNricMsgCodeStatus("invalidNric");
          setTimeout(() => {
            setPromoCodeStatus("");
          }, 2000);
        }
        //dispatch(setLoadingState(false));
        return false;
      } catch (error) {
        //dispatch(setLoadingState(false));
        setHasCheckNric(true);
        setValidNric(true);
        resetCheck();
        setPromoCodeStatus("error");
        setPromoMsgCodeStatus("error");
        setNricMsgCodeStatus("error");
        setTimeout(() => {
          setPromoCodeStatus("");
        }, 2000);
        return true; //bypass
      }
    },
    [dispatch, quotes, values],
  );

  const onCheckPromoNric = useCallback(async () => {
    const result = additionalNricChecks(
      values["promoNric"],
      values["promoCode"],
    );
  }, [additionalNricChecks, values]);

  const onMonthlyCostChange = useCallback(
    debounce((value) => {
      setMonthlyBenefitsAmountSelection(value);
      dispatch(updateMonthlyBenefitsAmountSelection(value));
    }, 100),
    [],
  );

  const validatePromoCode = useCallback(
    (pocket: any) => {
      const promoCodeSummary = values["promoCode"].toUpperCase();
      if (isEmpty(promoCodeSummary)) {
        setPromoCodeError("");
        setRequirePromoNric(false);
        return;
      }
      const checkedCode = pocket.checkValidPromoCode(promoCodeSummary);
      const { valid, error } = checkedCode;

      if (!valid) {
        setRequirePromoNric(false);
        patchValue({ promoNric: "" });
      }
      // else if (!requirePromoNric && isCalculated) {
      //   dispatch(updateCoverage(values));
      //   setAppliedPromoCode(true);
      // }
      else if (requirePromoNric && validNric) {
        setAppliedPromoCode(true);
      }
      setPromoCodeError(error);
    },
    [values, requirePromoNric, validNric, patchValue],
  );

  const calculatePremiumQuoteBreakdown = useCallback(
    async (enableQuoteBreakDown) => {
      if (!basicDetails) {
        onBack();
        return;
      }
      setIsLoading(true);

      //TODO: Create SQSPocketRequest Payload!
      const payload: SQSPocketRequest = createSQSPayload({
        basicDetails,
        coverage: values,
        campaignCode: campaignDetail?.campaignCode || "",
        nricValue: gioNricDetails,
      });
      dispatch(updateQuoteRequest({ ...payload }));

      try {
        const response = await postComputePremium(payload, true);
        const error: String = get(response, "data.error", {});
        const data = get(response, "data.data", {});
        if (error !== null && error.includes("Invalid gender code")) {
          history.push(
            "/mltc/lets-get-started?gendercodeerror=true" +
              combineParamCC +
              combineAnalyticParam,
          );
          return;
        }

        ////Mock
        // const response = computeQuoteMocks;
        // const data = get(response, 'data', {});

        const pocket = new SQSPocketResponse({
          ...data,
          planStructure: planStructure?.value,
          planStructureDesc: planStructure?.description,
          premiumTerm: planDetailsFromStore?.premiumTerm || premiumTerm?.terms,
          premiumTermDesc:
            planDetailsFromStore?.premiumTermDesc || premiumTerm?.description,
          premiumTermOption:
            planDetailsFromStore?.premiumTermOption || premiumTerm?.value,
          planName: values["plan"],
        });

        setCalculatedPremium(pocket);
        validatePromoCode(pocket);
        dispatch(updateCoverage(values));
        dispatch(updateSQSQuotation(pocket));
        dispatch(updateQuoteResponse(data));

        setIsLoading(false);
        enableQuoteBreakDown
          ? setQuoteBreakdown(true)
          : setQuoteBreakdown(false);
      } catch (error) {
        setIsLoading(false);
        setQuoteBreakdown(false);
      }
    },
    [
      handleChange,
      values,
      setCheckedPromoCode,
      validatePromoCode,
      gioNricDetails,
      isValidNRICResponse,
      gioDeclaration,
    ],
  );

  useEffect(() => {
    //Add click listener to the promocode edit button!
    const elements = document.getElementsByClassName("insertPromoCodeClass");
    if (elements[0]) {
      elements[0].addEventListener(
        "click",
        () => {
          setIsPromoCodeVisible(true);
        },
        false,
      );
    }
  });

  const calculateCPFAmount = useCallback(async () => {
    setCalculating(true);

    // //TODO: Create SQSPocketRequest Payload!
    const payload: SQSPocketRequest = createSQSPayload({
      basicDetails,
      coverage: values,
      campaignCode: campaignDetail?.campaignCode || "",
      nricValue: gioNricDetails,
    });

    dispatch(updateQuoteRequest({ ...payload }));
    try {
      const response = await postComputePremium(payload, true);
      const data = get(response, "data.data", {});
      const pocket = new SQSPocketResponse({
        ...data,
        planStructure: planStructure?.value,
        planStructureDesc: planStructure?.description,
        premiumTerm: premiumTerm?.terms,
        premiumTermOption: premiumTerm?.value,
        premiumTermDesc: premiumTerm?.description,
        planName: values["plan"],
      });
      dispatch(updateQuoteResponse(data));
      setCalculatedPremium(pocket);
      validatePromoCode(pocket);
      resetQuoteListing();
      setCalculating(false);
    } catch (error) {
      setCalculating(false);
    }
  }, [handleChange, values]);

  const resetQuoteListing = () => {
    dispatch(updateSQSQuotation(null));
    dispatch(confirmQuotation(false));
  };

  const resetCheck = useCallback(
    (value: any = {}) => {
      const nextValues = {
        ...values,
        ...value,
        promoCode: "",
        promoNric: "",
      };
      patchValue(nextValues);
      const basicTarget = find(quotes, { type: "basic" });
      set(basicTarget, "details[5].value", "-");
      set(basicTarget, "details[6].value", "-");
      setQuotes([...quotes]);
      setRequirePromoNric(false);
      setValidNric(false);
      setIsCalculated(false);
      setHasCheckNric(false);
      setAppliedPromoCode(false);
      setCheckedPromoCode("");
      setPromoCodeStatus("");
      setPromoMsgCodeStatus("");
      setNricMsgCodeStatus("");
      dispatch(updateCoverage(new CoverageForm(nextValues)));
    },
    [values, dispatch, patchValue, quotes],
  );

  const onChange = (e: any) => {
    if (e.target.name === "promoCode") {
      resetCheck();
    }
    handleChange(e);
  };

  const onCheckPromoCode = useCallback(
    async (reset: boolean = false) => {
      const promoCodeSummary = reset ? "" : values["promoCode"].toUpperCase();
      const payload: SQSPocketRequest = createSQSPayload({
        basicDetails,
        coverage: values,
        promoCodeSummary,
        campaignCode: campaignDetail?.campaignCode || "",
        nricValue: gioNricDetails,
      });
      try {
        const response = await postComputePremium(payload, true);
        let data: any = get(response, "data.data", {});
        const coverageBasePlan: any =
          data?.coverages[0]?.attributes?.discountedPremium; //find(data?.coverages as any, {"type": 'P'});
        if (!coverageBasePlan) {
          data = lastSqsResponse;
        }
        const pocket = new SQSPocketResponse({
          ...data,
          planStructure: planStructure?.value,
          planStructureDesc: planStructure?.description,
          premiumTerm: premiumTerm?.terms,
          premiumTermOption: premiumTerm?.value,
          premiumTermDesc: premiumTerm?.description,
          planName: values["plan"],
        });
        dispatch(updateQuoteResponse(data));
        setPremium({
          ...pocket.mltcPremium,
          // totalOriginalPremiumAmt: pocket.totalOriginalPremiumAmt,
          firstYearDiscountEligible: pocket.firstYearDiscountEligible,
          totalDiscount:
            pocket.coverages[0].attributes?.discountedPremium?.totalDiscount,
          discountedAnnualPremium:
            pocket.coverages[0].attributes?.discountedPremium?.annualPremium,
        });
        setRequirePromoNric(pocket.additionalChecks || false);
        const checkedCode = pocket.checkValidPromoCode(promoCodeSummary);
        const { valid, error } = checkedCode;

        if (pocket.additionalChecks && valid) {
          //Required IC!
          setAppliedPromoCode(false);
        } else {
          if (!valid) {
            setRequirePromoNric(false);
            setCalculatedPremium(pocket);
            setCheckedPromoCode("");
            patchValue({ promoNric: "" });
            //Promocode not valid!
            setPromoCodeStatus("invalid");
            setPromoMsgCodeStatus("invalid");
            setNricMsgCodeStatus("");
            setTimeout(() => {
              setPromoCodeStatus("");
            }, 2000);
            setAppliedPromoCode(false);
          }
          // else if (!requirePromoNric && isCalculated) {
          //   dispatch(updateCoverage(values));
          //   setAppliedPromoCode(true);
          //   setCheckedPromoCode(promoCodeSummary);
          // }
          // else if (requirePromoNric) {
          //   // dispatch(updateCoverage(values));
          // }
          else {
            setAppliedPromoCode(true);
            setCalculatedPremium(pocket);
            setPromoCodeStatus("success");
            setPromoMsgCodeStatus("success");
            setNricMsgCodeStatus("");
            setTimeout(() => {
              setPromoCodeStatus("");
              // setIsPromoCodeVisible(false);
            }, 3000);
            setCheckedPromoCode(promoCodeSummary);
            const basicTarget = find(quotes, { type: "basic" });
            set(basicTarget, "details[6].value", promoCodeSummary);
            setQuotes([...quotes]);
            const nextValues = {
              ...values,
              promoCode: promoCodeSummary,
            };
            dispatch(updateCoverage(new CoverageForm(nextValues)));
            dispatch(updateSQSQuotation(pocket));
            dispatch(updateQuoteResponse(data));
          }
        }

        setPromoCodeError(error);
      } catch (error) {
        patchValue({ promoCode: "" });
        setAppliedPromoCode(false);
        setPromoCodeError(get(error, "message", ""));
        setPromoCodeStatus("error");
      }
    },
    [handleChange, values, setCheckedPromoCode, setPromoCodeStatus],
  );

  const onBack = useCallback(() => {
    history.push("/mltc/lets-get-started" + paramCC + analyticParam);
  }, [history]);

  const processQuoteBreakdowns = useCallback(
    (premiumValue: any) => {
      let obj = [
        {
          heading: { text: "Plan Overview" },
          descriptions: [
            {
              text: "Plan Selected",
              value: `${
                values["plan"] === "MLTC"
                  ? planOptions.options[0].description
                  : planOptions.options[1].description
              }`,
            },
            {
              text: "Monthly Benefit",
              value: `${premiumValue.monthlyBenefit.value}`,
            },
          ],
        },
        {
          heading: { text: "Premium Breakdown^" },
          descriptions: [
            {
              text: "Annual Premium",
              value: `${Helpers.toCurrency(
                premiumValue?.nonDiscountedTotalPremium,
              )}`,
            },
            { text: "", value: "" },
          ],
        },
      ];

      let promoText =
        isValidPromoCode === "Y"
          ? ""
          : isEBLTC
          ? '<p class="insertPromoTextClass">Promo Code: </p>'
          : '<p class="insertPromoTextClass">Promo Code: <a class="insertPromoCodeClass">Edit</a></p>';

      if (premiumValue?.details[1]) {
        const basicTarget = find(quotes, { type: "basic" });
        const promotions = premiumValue?.details[1]?.promotions || [];

        const promo0 = promotions[0];
        const promo1 = promotions[1];

        let discountDescription = "";

        if (promo0) {
          discountDescription = `${promo0.value} ${promo0.text}`;
          if (promo1) {
            discountDescription += ` + additional ${promo1.value} ${promo1.text}`;
          }
        }
        if (discountDescription) {
          dispatch(updateQRLTCDiscountDescription(discountDescription));
        }

        if (premium.firstYearDiscountEligible) {
          promoText +=
            isValidPromoCode === "Y" ||
            (csTopupValid && sqsPromoCode === "CS35")
              ? `${premiumValue?.details[1].promotions[0].value || ""} ${
                  premiumValue?.details[1].promotions[0].text || ""
                } + additional ${
                  premiumValue?.details[1].promotions[1].value || ""
                } ${(
                  premiumValue?.details[1].promotions[1].text || ""
                ).toLowerCase()}`
              : isEBLTC
              ? `<p><span style="font-weight:600;">${
                  basicTarget.details[6].value
                }</span> (${
                  premiumValue?.details[1].promotions[0].value || ""
                } ${
                  premiumValue?.details[1].promotions[0].text || ""
                } + additional ${
                  premiumValue?.details[1].promotions[1].value || ""
                } ${(
                  premiumValue?.details[1].promotions[1].text || ""
                ).toLowerCase()} + up to S$599 off first-year discount)</p>`
              : `<p><span style="font-weight:600;">${
                  basicTarget.details[6].value
                }</span> (${
                  premiumValue?.details[1].promotions[0].value || ""
                } ${
                  premiumValue?.details[1].promotions[0].text || ""
                } + additional ${
                  premiumValue?.details[1].promotions[1].value || ""
                } ${(
                  premiumValue?.details[1].promotions[1].text || ""
                ).toLowerCase()})</p>`;
        } else {
          premiumValue?.details[1].promotions.map((e: any) => {
            promoText +=
              isValidPromoCode === "Y" ||
              (csTopupValid && sqsPromoCode === "CS35")
                ? `<p> ${e.value} ${e.text}</p>`
                : isEBLTC
                ? `<p><span style="font-weight:600;">${basicTarget.details[6].value}</span> (${e.value} ${e.text} + up to S$599 off first-year discount)</p>`
                : `<p><span style="font-weight:600;">${basicTarget.details[6].value}</span> (${e.value} ${e.text})</p>`;
          });
        }
      }

      obj[1].descriptions[1].text = promoText;
      // if(premium.perpetualDiscountEligible)
      // {
      //   const basicTarget = find(quotes, { type: 'basic' });
      //   obj[1].descriptions.push(
      //     { text: `${basicTarget[6].value} (20% Perpetual discount)`,value:""}
      //   );
      // }
      // if(premium.perpetualDiscountEligible)
      // {
      //   const basicTarget = find(quotes, { type: 'basic' });
      //   obj[1].descriptions.push(
      //     { text: `${basicTarget[6].value} (20% Perpetual discount)`,value:""}
      //   );
      // }

      if (premiumValue?.details[0].hasDiscount) {
        // obj[1].descriptions[1].value = `-${Helpers.toCurrency(premiumValue.totalOriginalPremiumAmt-premiumValue.totalAnnualizedPremium)}`;
        obj[1].descriptions[1].value = `-${Helpers.toCurrency(
          premiumValue.discountedValue || "",
        )}`;
        const formattedAnnualAmount =
          +premiumValue?.details[0].value.replace(/\D/g, "") / 100;
        const formattedDiscountAmount =
          +premiumValue?.details[1].value.replace(/\D/g, "") / 100;
        dispatch(
          updatePercentage(
            Math.round(
              ((formattedAnnualAmount - formattedDiscountAmount) /
                formattedAnnualAmount) *
                100,
            ),
          ),
        );
      } else {
        if (isValidPromoCode !== "Y") {
          obj[1].descriptions[1].value = "-";
        }
        dispatch(updatePercentage(0));
      }

      if (premiumValue.totalDiscount) {
        obj[1].descriptions.push({
          text: isEBLTC
            ? "First-Year Annual Premium (after discount)"
            : "Annual Premium (after discount)",
          value: Helpers.toCurrency(
            +premiumValue?.discountedTotalFirstYrPremium,
          ),
        });

        if (isEBLTC) {
          obj[1].descriptions.push({
            text: "MediSave Deduction",
            value: `-${Helpers.toCurrency(1)}`,
          });
        }
      }
      setPlanOverview([...obj]);

      let tempSummarizationSummarySources = summarizationSummarySources;
      set(
        tempSummarizationSummarySources,
        "value",
        isNumber(premiumValue?.cashPayment)
          ? Helpers.toCurrency(premiumValue?.cashPayment)
          : "-",
      );

      if (premiumValue.firstYearDiscountEligible) {
        const text =
          campaignDetail?.partner === "DDM18"
            ? "Cash Payment - 1st year"
            : "Cash Payment - 1st year*";
        set(tempSummarizationSummarySources, "text", text);
        // setShowDisclaimer(true);
      } else {
        set(tempSummarizationSummarySources, "text", "Cash Payment");
        // setShowDisclaimer(true);
      }

      setPlanSummaryOverview({ ...tempSummarizationSummarySources });
      dispatch(
        updatePlanOverview({
          quoteBreakdown: obj,
          summary: { ...tempSummarizationSummarySources },
        }),
      );
    },
    [setPremium, premium],
  );

  const onPlanSelection = (planSelection: string) => {
    let obj = [
      {
        heading: { text: "Plan Overview" },
        descriptions: [
          {
            text: "Plan Selected",
            value: `${
              planSelection === "MLTC"
                ? planOptions.options[0].description
                : planOptions.options[1].description
            }`,
          },
          { text: "Monthly Benefit", value: `-` },
        ],
      },
      {
        heading: { text: "Premium Breakdown" },
        descriptions: [
          { text: "Annual Premium", value: `-` },
          {
            text: 'Promo Code: <a class="insertPromoCodeClass">Edit</a>',
            value: "-",
          },
        ],
      },
    ];

    // obj[1].descriptions.push({ text: 'Annual Premium (after discount)', value: `-`,});
    dispatch(updatePlanOverview({ quoteBreakdown: obj }));
  };

  const setCalculatedPremium = useCallback(
    (_premium: SQSPocketResponse) => {
      const premiumValue = {
        ..._premium.mltcPremium,
        // totalOriginalPremiumAmt: _premium.totalOriginalPremiumAmt,
        firstYearDiscountEligible: _premium.firstYearDiscountEligible,
        totalDiscount:
          _premium.coverages[0].attributes?.discountedPremium?.totalDiscount,
        discountedAnnualPremium:
          _premium.coverages[0].attributes?.discountedPremium?.annualPremium,
      };
      let basicTarget = find(quotes, { type: "basic" });
      let planName =
        values["plan"] === "MLTC"
          ? planOptions.options[0].description
          : planOptions.options[1].description;
      set(basicTarget, "details[0].value", planName);
      set(
        basicTarget,
        "details[1].value",
        values["monthlyBenefit"]
          ? Helpers.toCurrency(Number(values["monthlyBenefit"]))
          : "-",
      );
      set(basicTarget, "details[2].value", planStructure?.description);
      set(basicTarget, "details[3].value", "Lifetime");
      set(basicTarget, "details[4].value", premiumTerm?.description);
      set(
        basicTarget,
        "details[5].value",
        Helpers.toCurrency(_premium.totalAftDisOriginalPremiumAmt || 0),
      );
      set(basicTarget, "details[6].value", _premium.promoCode);

      setQuotes([...quotes]);
      setPremium(premiumValue);

      //#endregion
      //? dispatch(updateDeclaration(null));
      //? dispatch(updateReadDocs(null));
      //? dispatch(completeStep4(false));
    },
    [
      handleChange,
      values,
      setCheckedPromoCode,
      setPremium,
      premium,
      setQuotes,
      dispatch,
      planStructure,
      premiumTerm,
      quotes,
      values,
      setPlanOverview,
      planOverview,
    ],
  );

  useEffect(() => {
    if (!isEmpty(premium)) {
      processQuoteBreakdowns(premium);
    }
  }, [setPremium, premium]);

  useEffect(() => {
    const ready =
      planStructure?.value &&
      premiumTerm?.value &&
      values?.monthlyBenefit &&
      values?.plan;

    if (!ready) return;

    calculateCPFAmount();
  }, [
    planStructure?.value,
    premiumTerm?.value,
    values?.monthlyBenefit,
    values?.plan,
    gioNricDetails,
    gioDeclaration,
  ]);

  if (
    promoApplied?.includes("DBS") &&
    premium?.nonDiscountedTotalPremium >= MLTC_DISCLAIMER_MIN_ANNUAL_PREMIUM
  ) {
    disclaimerContentArray.push(DISCLAIMER_TEXT);
  }

  useEffect(() => {
    if (lastSqsResponse && Array.isArray(lastSqsResponse.campaigns)) {
      const gioCampaign = lastSqsResponse.campaigns.find(
        (c: any) => c.code === "GIO",
      );
      const CSTOPUPCampaign = lastSqsResponse.campaigns.find(
        (c: any) => c.code === "CSTOPUP",
      );
      setShowNRICAlert(true);
      setIsValidNRICResponse(gioCampaign?.campaignValid);
      setCsTopupValid(CSTOPUPCampaign?.campaignValid);
      setScrollTrigger((prev) => prev + 1);
      dispatch(updateCSTOPUPCampaignValidity(CSTOPUPCampaign?.campaignValid));
      if (gioCampaign?.campaignValid && gioCampaign?.maxMonthlyBenefit) {
        setMaxGIOMonthlyBenefit(gioCampaign.maxMonthlyBenefit);
      }
      if (!gioCampaign?.campaignValid) {
        dispatch(updateGIODeclaration(""));
      }
    } else {
      setShowNRICAlert(false);
      setIsValidNRICResponse(false);
      setCsTopupValid(false);
      dispatch(updateGIODeclaration(""));
    }
  }, [lastSqsResponse, dispatch]);

  const handleBlur = async () => {
    calculatePremiumQuoteBreakdown(false);
  };

  const onNRICChange = (e: any) => {
    dispatch(updateGIONRICDetails(e.target.value));
  };

  const buttonLabelOnQuotePage =
    gioDeclaration === "GIO"
      ? "Proceed to purchase"
      : "Start health declaration";

  const handleButtonLabelOnQuotePageClick = () => {
    dispatch(
      updatePlanOverview({
        quoteBreakdown: planOverview,
        summary: planSummaryOverview,
      }),
    );
    dispatch(confirmQuotation(true));

    if (gioDeclaration === "GIO") {
      history.push("/mltc/my-info" + paramCC + analyticParam);
    } else {
      history.push("/mltc/check-eligibility" + paramCC + analyticParam);
    }
  };

  useEffect(() => {
    if (monthlyBenefit != null) return;
    if (!isValidNRICResponse || gioDeclaration !== "GIO") {
      handleChange({ target: { name: "monthlyBenefit", value: 3000 } });
      dispatch(updateMonthlyBenefitsAmountSelection(3000));
    }
  }, [isValidNRICResponse, gioDeclaration, dispatch, handleChange]);

  useEffect(() => {
    if (gioDeclaration && gioDeclaration.trim() !== "") {
      calculatePremiumQuoteBreakdown(false);
    }
  }, [gioDeclaration]);

  const sliderInitialValue =
    isValidNRICResponse && gioDeclaration === "GIO" && maxGIOMonthlyBenefit
      ? Math.min(3000, maxGIOMonthlyBenefit)
      : 3000;

  const handlePremiumTermChange = (input: any) => {
    let premiumTermYearsTarget: any;
    let premiumTermValue: any;

    premiumTermOptions.options = [
      {
        value: "OPTION_LIMITED",
        description: `For ${
          currentAge >= 49 ? 20 : 69 - currentAge
        } years, until I'm ${
          currentAge >= 49 ? currentAge + 20 : 69
        } Age Next Birthday`,
        age: currentAge >= 49 ? 20 : 69 - currentAge,
        key: "limited",
        terms: `${currentAge >= 49 ? 20 : 69 - currentAge}`,
      },
      {
        value: "OPTION_LIFETIME",
        description: `For ${
          99 - currentAge
        } years, until I'm 99 Age Next Birthday`,
        age: 99 - currentAge,
        key: "lifetime",
        terms: `${99 - currentAge}`,
      },
    ];

    if (input.target.value === "limited") {
      premiumTermYearsTarget = {
        target: {
          name: "premiumTermYears",
          value: currentAge >= 49 ? 20 : 69 - currentAge,
        },
      };
      premiumTermValue = premiumTermOptions.options[0];
    } else {
      premiumTermYearsTarget = {
        target: { name: "premiumTermYears", value: 99 - currentAge },
      };
      premiumTermValue = premiumTermOptions.options[1];
    }

    setPlanStructure(planStructureOptions.options[0]);
    handleChange(input);
    handleChange(premiumTermYearsTarget);
    setTermSelection(input.target.value);

    setPremiumTerm((prev: any) => {
      if (input.target.value !== prev) {
        resetQuoteListing();
      }
      return premiumTermValue;
    });

    setQuoteBreakdown(false);
    dispatch(updateCoverageTerm(input.target.value));
  };

  useEffect(() => {
    if (values?.premiumTerm) return;
    if (!QRTermValue) return;
    if (!currentAge || currentAge === 0) return;

    const autoValue = QRTermValue === "99" ? "lifetime" : "limited";
    handleChange({ target: { name: "premiumTerm", value: autoValue } });
    handlePremiumTermChange({
      target: { name: "premiumTerm", value: autoValue },
    });
    setTermSelection(autoValue);
  }, [QRTermValue, values?.premiumTerm, currentAge]);

  useEffect(() => {
    if (values?.premiumTerm) {
      setTermSelection(values.premiumTerm);
      return;
    }
  }, [values?.premiumTerm, QRTermValue]);

  useEffect(() => {
    dispatch(updatePlanSelection(planSelected));
  }, [planSelected]);

  useEffect(() => {
    if (hasHydrated) return;

    if (QRMonthlyBenefitValue) {
      const parsed = parseInt(QRMonthlyBenefitValue, 10);
      if (!isNaN(parsed)) {
        handleChange({
          target: { name: "monthlyBenefit", value: parsed },
        });
        dispatch(updateMonthlyBenefitsAmountSelection(parsed));
        setMonthlyBenefitsAmountSelection(parsed);
      }
    } else if (!monthlyBenefit) {
      handleChange({
        target: { name: "monthlyBenefit", value: sliderInitialValue },
      });
      dispatch(updateMonthlyBenefitsAmountSelection(sliderInitialValue));
      setMonthlyBenefitsAmountSelection(sliderInitialValue);
    }

    dispatch(setHasHydratedMonthlyBenefit(true));
  }, [hasHydrated, QRMonthlyBenefitValue]);

  const isCSTopupApplied = showNRICAlert && csTopupValid;
  const isGIOApplied = showNRICAlert && isValidNRICResponse;

  useEffect(() => {
    if (isCSTopupApplied || isGIOApplied) {
      setTimeout(() => {
        const el = exclusiveOffersRef.current;
        if (!el) return;

        const OFFSET = 175;

        const y = el.getBoundingClientRect().top + window.pageYOffset - OFFSET;

        window.scrollTo({
          top: y,
          behavior: "smooth",
        });
      }, 0);
    }
  }, [scrollTrigger]);

  const shouldShowNRICSection = !validQRClient && !isEBLTC;

  const shouldShowExclusiveOffersHeader = !(
    validQRClient &&
    !isCSTopupApplied &&
    !isGIOApplied && 
    !isEBLTC
  );

  useEffect(() => {
    if (resetQRData) {
      setShowNRICAlert(false);
      handleChange({ target: { name: "monthlyBenefit", value: 3000 } });
      dispatch(updateMonthlyBenefitsAmountSelection(3000));

      handleChange({ target: { name: "premiumTerm", value: "" } });
      setTermSelection("");
    }
  }, [resetQRData]);

  const onHandleMaxCoverage = () => {
    window.location.replace(QR_LTC_MAX_COVERAGE_LINK);
  }

  useEffect(() => {
    if (validQRClient && clientQRData?.existingMonthlyBenefit >= 5000) {
      setShowQRLTCMaxCoverageModal(true);
    }
  }, [validQRClient, clientQRData?.existingMonthlyBenefit]);

  return (
    <Container>
      <Spinner show={isLoading} />
      <FormContainer maxWidth={"792px"}>
        <FormContentContainer>
          <HeaderContainer>
            <div className={headingText}>
              <Text theme={themeDefault} className={HeaderTitleCss}>
                Let's customise your plan:
              </Text>
            </div>
            <div style={{ flex: 4, width: "100%", marginTop: "1.5rem" }}>
              <RadioButtonGroup
                name="plan"
                theme={themeDefault}
                onChange={(input) => {
                  handleChange(input);
                  setPlanSelection((prev) => {
                    if (input.target.value !== prev) {
                      //When plan change, reset the header component view plan amount
                      resetQuoteListing();
                    }
                    return input.target.value;
                  });
                  onPlanSelection(input.target.value);
                  dispatch(updatePlanSelection(input.target.value));
                  setQuoteBreakdown(false);
                }}
                activeType={"fill"}
                value={planSelected}
                widthIcon={false}
                textAlign={"center"}
                borderRadius={"12px"}
                buttonGap={"8px"}
              >
                <RadioButton
                  value={"MLTC"}
                  padding="16px"
                  justifyContent="center"
                  text="Singlife CareShield Standard"
                  subText={
                    validQRClient ? (
                      <>
                        Payouts begin when the insured is unable to perform{" "}
                        <b>
                          at least 2 Activities of Daily Living (ADLs).
                        </b>
                      </>
                    ) : undefined
                  }
                />
                <RadioButton
                  value={"MLTCP"}
                  padding="16px"
                  justifyContent="center"
                  text="Singlife CareShield Plus"
                  subText={
                    validQRClient ? (
                      <>
                        Payouts begin when the insured is unable to perform{" "}
                        <b>
                          at least 1 Activity of Daily Living (ADL).
                        </b>
                      </>
                    ) : undefined
                  }
                />
              </RadioButtonGroup>
            </div>
          </HeaderContainer>
        </FormContentContainer>
      </FormContainer>
      <FormContainer maxWidth={"792px"} margin={"24px auto 0 auto"}>
        <FormHeaderContainer>
          <FormHeaderTitleContainer marginHorizontal={"0px"}>
            <LeftBorder />
            <Text theme={themeDefault} className={HeaderMonthlyBenefitTitleCss}>
              How long would you like to pay for this plan?{" "}
              <IconElement
                src={infoIcon}
                alt="info-icon"
                onClick={(e: any) => {
                  const targetClientRect = e.target.getBoundingClientRect();
                  displayModal(
                    1,
                    targetClientRect.left + 15,
                    targetClientRect.top + targetClientRect.height,
                    "click",
                  );
                }}
                onMouseOver={(e: any) => {
                  const targetClientRect = e.target.getBoundingClientRect();
                  displayModal(
                    1,
                    targetClientRect.left + 15,
                    targetClientRect.top + targetClientRect.height,
                  );
                }}
                onMouseLeave={() => hideModal(1)}
              />
            </Text>
          </FormHeaderTitleContainer>
          <FormHeaderDescriptionContainer>
            <Text theme={themeDefault} className={HeaderDescriptionCss}>
              Select a comfortable duration that suits your needs.
            </Text>
          </FormHeaderDescriptionContainer>
        </FormHeaderContainer>
        <FormContentContainer margin="24px 0 0 0">
          <RadioButtonGroup
            name="premiumTerm"
            theme={themeDefault}
            onChange={handlePremiumTermChange}
            activeType={"fill"}
            value={values["premiumTerm"]}
            widthIcon={false}
            textAlign={"center"}
            borderRadius={"12px"}
            buttonGap={"8px"}
          >
            <RadioButton
              padding="16px"
              justifyContent="center"
              text={`Pay yearly for ${
                currentAge >= 49 ? 20 : 69 - currentAge
              } years until I'm ${currentAge >= 49 ? currentAge + 20 : 69}`}
              value={"limited"}
            />
            <RadioButton
              padding="16px"
              justifyContent="center"
              text={`Pay yearly for ${99 - currentAge}  years until I'm 99`}
              value={"lifetime"}
            />
          </RadioButtonGroup>
        </FormContentContainer>
      </FormContainer>

      {termSelection !== "" && (
        <>
          {isCampaignEligible || isEBLTC ? (
            <>
              <FormContainer
                maxWidth={"792px"}
                margin={shouldShowExclusiveOffersHeader ? "64px auto 0" : "0"}
              >
                {shouldShowExclusiveOffersHeader && (
                  <div ref={exclusiveOffersRef}>
                    <FormHeaderContainer>
                      <FormHeaderTitleContainer marginHorizontal={"0px"}>
                        <LeftBorder />
                        <Text
                          theme={themeDefault}
                          className={HeaderMonthlyBenefitTitleCss}
                        >
                          {validQRClient || isEBLTC
                            ? "Exclusive offers for existing Singlife customers"
                            : "Exclusive offers for existing Singlife CareShield policyholders"}
                        </Text>
                      </FormHeaderTitleContainer>
                    </FormHeaderContainer>
                  </div>
                )}
                {isEBLTC && (
                  <div className={campaignCriteriaAppliedSectionCss}>
                    <div className={termsAppliedSectionCss}>
                      <div className={termsAppliedHeadingCss}>
                        <IconElement
                          src={promoDiscountAppliedIcon}
                          alt="promo-discount-icon"
                        />
                        Singlife EB campaign
                      </div>
                      <div className={appliedLabelCss}>
                        <span>Applied</span>
                      </div>
                    </div>
                    <div className={termsAppliedCss}>
                      <div>
                        For your first-year premium, pay just S$1 from your CPF
                        MediSave and get up to S$599 off.{" "}
                        <Link
                          theme={themeDefault}
                          target="_blank"
                          rel="noopener noreferrer"
                          url={EBLTC_TERMS_AND_CONDITIONS}
                          text="T&Cs"
                          fontSize={14}
                          fontSizeTablet={14}
                          color="#0A544F"
                        />{" "}
                        apply.
                      </div>
                    </div>
                  </div>
                )}
                {isCSTopupEligible && !isEBLTC && (
                  <>
                    {validQRClient ? (
                      isCSTopupApplied && (
                        <div className={campaignCriteriaAppliedSectionCss}>
                          <div className={termsAppliedSectionCss}>
                            <div className={termsAppliedHeadingCss}>
                              <IconElement
                                src={promoDiscountAppliedIcon}
                                alt="promo-discount-icon"
                              />
                              35% Lifetime Premium Discount
                            </div>
                            <div className={appliedLabelCss}>
                              <span>Applied</span>
                            </div>
                          </div>
                          <div className={termsAppliedCss}>
                            <div>
                              Enjoy 35% off your annual premium when it is S$550
                              and above.
                              <Link
                                theme={themeDefault}
                                target="_blank"
                                rel="noopener noreferrer"
                                url={CSTOPUP_TERMS_AND_CONDITIONS}
                                text="T&Cs"
                                fontSize={14}
                                fontSizeTablet={14}
                                color="#0A544F"
                              />{" "}
                              apply.
                            </div>
                          </div>
                        </div>
                      )
                    ) : (
                      <div className={campaignCriteriaSectionCss}>
                        <div className={termsHeadingCss}>
                          <IconElement
                            src={promoDiscountIcon}
                            alt="promo-discount-icon"
                          />
                          35% Lifetime Premium Discount
                        </div>
                        <div className={termsCss}>
                          <div>
                            Enjoy 35% off your annual premium when it is S$550
                            and above.
                            <Link
                              theme={themeDefault}
                              target="_blank"
                              rel="noopener noreferrer"
                              url={CSTOPUP_TERMS_AND_CONDITIONS}
                              text="T&Cs"
                              fontSize={14}
                              fontSizeTablet={14}
                            />{" "}
                            apply.
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
                {isGIOEligible && !isEBLTC && (
                  <>
                    {validQRClient ? (
                      isGIOApplied && (
                        <div className={campaignCriteriaAppliedSectionCss}>
                          <div className={termsAppliedSectionCss}>
                            <div className={termsAppliedHeadingCss}>
                              <IconElement
                                src={UnderwritingAppliedIcon}
                                alt="underwriting-applied-icon"
                              />
                              Underwriting Campaign
                            </div>
                            <div className={appliedLabelCss}>
                              <span>Applied</span>
                            </div>
                          </div>
                          <div className={termsAppliedCss}>
                            <div>
                              You can now increase your monthly benefit up to{" "}
                              {Helpers.toCurrencyND(maxGIOMonthlyBenefit ?? 0)}{" "}
                              without additional underwriting.
                            </div>
                          </div>
                        </div>
                      )
                    ) : (
                      <div className={campaignCriteriaSectionCss}>
                        <div className={termsHeadingCss}>
                          <IconElement
                            src={campaignIcon}
                            alt="promo-discount-icon"
                          />
                          Underwriting Campaign
                        </div>
                        <div className={termsCss}>
                          <div>
                            You're eligible for this campaign without going
                            through additional underwriting if:
                            <ol
                              style={{
                                listStyleType: "disc",
                                padding: "0 1.5rem",
                              }}
                            >
                              <li>
                                You are an existing Singlife CareShield Standard
                                or Singlife CareShield Plus policyholder within
                                the campaign period;
                              </li>
                              <li>
                                Your cumulative total Monthly Benefit for
                                Singlife CareShield Standard and/or Singlife
                                CareShield Plus cannot exceed the following
                                non-medical limits based on your age:
                                <ol
                                  style={{
                                    listStyleType: "disc",
                                    padding: "0 2rem",
                                    fontWeight: "600",
                                  }}
                                >
                                  <li>
                                    S$4,000 for 31–45 years old (age next
                                    birthday)
                                  </li>
                                  <li>
                                    S$3,000 for 46–55 years old (age next
                                    birthday)
                                  </li>
                                </ol>
                              </li>
                              <li>
                                You have applied for and purchased only a
                                Singlife CareShield Standard policy if you are
                                an existing Singlife CareShield Standard
                                policyholder.
                              </li>
                            </ol>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
                {shouldShowNRICSection && (
                  <>
                    <div className={noteSectionCss}>
                      {" "}
                      Let's check your eligibility{" "}
                    </div>
                    {genericError && (
                      <ErrorMessage>
                        <Icon name="alert-circle-red" width={18} />
                        <Typography
                          color="#434343"
                          variant="base"
                          fontWeight={400}
                        >
                          {genericError}
                        </Typography>
                      </ErrorMessage>
                    )}
                    <FormContentContainer
                      style={{ display: "block", width: "100%" }}
                      margin={"16px 0 0"}
                    >
                      <label className={nricEligibilityCss}>
                        Enter your NRIC
                      </label>
                      <Input
                        id="nric"
                        name="nric"
                        placeholder=""
                        value={gioNricDetails}
                        onChange={onNRICChange}
                        onBlur={handleBlur}
                        type="alphanumeric"
                        color="#883e89"
                        fontWeight={600}
                        margin={"8px auto"}
                      />
                      {isCSTopupApplied || isGIOApplied ? (
                        <div className={noteAppliedCss}>
                          {" "}
                          <img
                            src={successTickIcon}
                            style={{
                              height: "1rem",
                              width: "1rem",
                              marginRight: "0.25rem",
                            }}
                            alt="icon-img"
                          />{" "}
                          Great! We've applied the offers that you're eligible
                          for.
                        </div>
                      ) : showNRICAlert &&
                        !isValidNRICResponse &&
                        !csTopupValid ? (
                        <div className={noteErrorCss}>
                          {" "}
                          <img
                            src={InfoErrorIcon}
                            style={{
                              height: "1rem",
                              width: "1rem",
                              marginRight: "0.25rem",
                            }}
                            alt="icon-img"
                          />{" "}
                          We couldn't find any records. Enter your NRIC again or
                          skip this step.
                        </div>
                      ) : (
                        <div className={noteCss}>
                          By providing your NRIC, you confirm that you have read
                          and understood the campaign criteria.
                        </div>
                      )}
                    </FormContentContainer>
                  </>
                )}
              </FormContainer>
              {isValidNRICResponse ? (
                <FormContainer maxWidth={"792px"} margin={"64px auto 0"}>
                  <FormHeaderContainer>
                    <FormHeaderTitleContainer marginHorizontal={"0px"}>
                      <LeftBorder />
                      <Text
                        theme={themeDefault}
                        className={HeaderMonthlyBenefitTitleCss}
                      >
                        Underwriting Campaign declaration{" "}
                      </Text>
                    </FormHeaderTitleContainer>
                  </FormHeaderContainer>

                  <FormContentContainer
                    style={{ display: "block", width: "100%" }}
                    margin={"24px 0 0"}
                  >
                    <RadioInput
                      name="declaration"
                      value="GIO"
                      checked={gioDeclaration === "GIO"}
                      onClick={() => {
                        dispatch(updateGIODeclaration("GIO"));
                      }}
                    >
                      I hereby declare that since my last Singlife CareShield
                      Standard and/or Singlife CareShield Plus policy with
                      Singlife, there have been no changes to my health
                      requiring investigation, ongoing medication, or regular
                      follow-ups. I hereby confirm that the declaration made is
                      valid and true as at the date of this application.
                    </RadioInput>
                    <RadioInput
                      name="declaration"
                      value="NON GIO"
                      checked={gioDeclaration === "NON GIO"}
                      onClick={() => {
                        dispatch(updateGIODeclaration("NON GIO"));
                      }}
                    >
                      The above declaration is not valid, I wish to submit a new
                      health declaration and go through full medical
                      underwriting.
                    </RadioInput>

                    <div className={underwritingCss}>
                      It is important that you confirm whether the health
                      declaration made by you when you enrolled into the
                      Underwriting Campaign is valid. For this application, if
                      you confirm that your health declaration under the
                      Underwriting Campaign is valid, we will rely on the
                      Underwriting Campaign’s health declaration made by you and
                      any Pre-existing Conditions or Pre-existing Disability
                      before the policy commencement date will not be covered.
                    </div>
                  </FormContentContainer>
                </FormContainer>
              ) : null}
            </>
          ) : null}

          <FormContainer maxWidth={"792px"} margin={"64px auto 0"}>
            <FormHeaderContainer>
              <FormHeaderTitleContainer marginHorizontal={"0px"}>
                <LeftBorder />
                <Text
                  theme={themeDefault}
                  className={HeaderMonthlyBenefitTitleCss}
                >
                  Tell us how much additional monthly benefit you need on top of
                  your basic CareShield Life payout{" "}
                  <IconElement
                    src={infoIcon}
                    alt="info-icon"
                    onClick={(e: any) => {
                      const targetClientRect = e.target.getBoundingClientRect();
                      displayModal(
                        2,
                        targetClientRect.left + 15,
                        targetClientRect.top + targetClientRect.height,
                        "click",
                      );
                    }}
                    onMouseOver={(e: any) => {
                      const targetClientRect = e.target.getBoundingClientRect();
                      displayModal(
                        2,
                        targetClientRect.left + 15,
                        targetClientRect.top + targetClientRect.height,
                      );
                    }}
                    onMouseLeave={() => hideModal(2)}
                  />
                </Text>
              </FormHeaderTitleContainer>
            </FormHeaderContainer>
            <FormContentContainer
              style={{ display: "block", width: "100%" }}
              margin={"24px 0 0"}
            >
              <SliderInput
                step={100}
                disabled={isCalculating}
                onBlur={(value) => {
                  handleChange({
                    target: { name: "monthlyBenefit", value: parseInt(value) },
                  });
                }}
                onChange={(value) => {
                  handleChange({
                    target: { name: "monthlyBenefit", value: parseInt(value) },
                  });
                  onMonthlyCostChange(parseInt(value));
                  setQuoteBreakdown(false);
                  dispatch(
                    updateMonthlyBenefitsAmountSelection(parseInt(value)),
                  );
                }}
                key={monthlyBenefit}
                initialValue={monthlyBenefit}
                min={
                  validQRClient
                    ? clientQRData?.existingMonthlyBenefit + 200
                    : 200
                }
                max={
                  isValidNRICResponse &&
                  gioDeclaration === "GIO" &&
                  maxGIOMonthlyBenefit
                    ? maxGIOMonthlyBenefit
                    : 5000
                }
                theme={themeDefault}
                validQRClient={validQRClient}
                existingMonthlyBenefit={clientQRData?.existingMonthlyBenefit}
                tickEnabled={false}
                //monthlyBenefit >= clientQRData?.maxMonthlyBenefit
              />
              {validQRClient && (
                <div className={recommendedLabelCss}>
                  Recommended Total Monthly Benefit:{" "}
                  {Helpers.toCurrencyND(clientQRData?.maxMonthlyBenefit)}
                </div>
              )}

              {isValidPromoCode === "Y" &&
                encryptedPromoCode !== sqsPromoCode && (
                  <div className={notificationHeading}>
                    <img
                      src={dollarIconImg}
                      width={24}
                      height={24}
                      alt="icon-img"
                    />
                    <span className="purple">
                      Set a higher monthly benefit to enjoy more discount!
                    </span>
                  </div>
                )}

              {monthlyBenefitsAmountSelection !== 0 && (
                <QuoteContainer>
                  <NotificationBox radius="16px">
                    <NotificationContent
                      iconProps={{ width: "22px", height: "22px" }}
                      isCalculating={isCalculating}
                      amount={premium.totalPremium?.value.toString()}
                      headerfontSize="14px"
                      descFontSize="12px"
                      existingMontlyBenefit={
                        clientQRData?.existingMonthlyBenefit
                      }
                      validQRClient={validQRClient}
                      recommendedMonthlyBenefit={Helpers.toCurrencyND(
                        clientQRData?.maxMonthlyBenefit,
                      )}
                      monthlyBenefit={monthlyBenefit}
                    ></NotificationContent>
                  </NotificationBox>
                  <QuoteListingContainer>
                    <Text className={QuoteListingTitleCss}>
                      Breakdown of additional care benefits
                    </Text>
                    {/* <Listing isCalculating={isCalculating} sources={sources} theme={themeDefault}></Listing> */}
                    <CardList
                      sources={sources}
                      validQRClient={validQRClient}
                    ></CardList>
                  </QuoteListingContainer>
                </QuoteContainer>
              )}
              <QuoteButtonContainer>
                <Button
                  onClick={() => {
                    dispatch(updateCoverage(values));
                    //TODO : API Request on the quotation breakdown
                    calculatePremiumQuoteBreakdown(true);
                    trackCTA();
                  }}
                  width={"318px"}
                  variant={"default"}
                  theme={themeDefault}
                  disabled={
                    monthlyBenefitsAmountSelection === 0 ||
                    isCalculating ||
                    (isValidNRICResponse && gioDeclaration === "")
                  }
                  label={"Get my quote"}
                ></Button>
              </QuoteButtonContainer>
            </FormContentContainer>
          </FormContainer>
        </>
      )}

      {isQuoteBreakdown === true && (
        <FormContainer
          maxWidth={"792px"}
          ref={formQuoteRef}
          margin="0 auto 0 auto"
        >
          {isValidPromoCode === "Y" && premium?.details[1] && (
            <AlertNotification
              iconImg={alertGreen}
              sideBarBackground={"#19D3C5"}
              background={"#eefdfc"}
            >
              <p className={`${promoAlertGreen}`}>
                {" "}
                Promo code applied. You'll get a{" "}
                <b>
                  {premium?.details[1]?.promotions.map(
                    (e: any, index: number) => (
                      <span key={index}>
                        {index === 1 ? "+ additional " : ""}
                        {e.value} {e.text}{" "}
                      </span>
                    ),
                  )}
                </b>{" "}
              </p>
            </AlertNotification>
          )}

          <FormHeaderContainer margin={"28px auto"}>
            <Text
              theme={themeDefault}
              className={HeaderTitleCss}
              align="center"
            >
              Your quote is ready
            </Text>
            <Text
              theme={themeDefault}
              className={HeaderDescriptionCss}
              align="center"
            >
              Do check that your quote details are correct before continuing.
            </Text>
          </FormHeaderContainer>
          {csTopupValid && premium?.nonDiscountedTotalPremium <= 550 && (
            <div className={CSTOPUPDiscountBanner}>
              <img src={warningIcon} alt="warning icon" />
              <div className={CSTOPUPDiscountBannerContent}>
                The 35% discount isn't available because your annual premium is
                below <span> below S$550 </span>.
              </div>
            </div>
          )}
          <FormContentContainer maxWidth={"792px"} margin={"0 auto"}>
            <Listing
              headerMaxValueWidth={"0"}
              sources={planOverview}
              summary={summarizationSummarySources}
              variant={"summarization"}
              theme={themeDefault}
              alignDescriptionItems="flex-start"
              summaryTextColor={themeDefault.colors.primary}
              showDisclaimer={showDisclaimer}
              disclaimerText={disclaimerContentArray}
            />
            <QuoteButtonContainer>
              <Button
                onClick={handleButtonLabelOnQuotePageClick}
                width={"fit-content"}
                variant={"default"}
                theme={themeDefault}
                label={buttonLabelOnQuotePage}
                padding={"16px 60px"}
              ></Button>
            </QuoteButtonContainer>
          </FormContentContainer>
          <AccordionContainer>
            <Accordion {...accordionArgs}>
              <div style={{ paddingBottom: "20px" }}>
                <Bullet>
                  <Text theme={themeDefault} className={AccordionParagraph}>
                    There is a 60-day free-look period after you've received the
                    policy contract.
                  </Text>
                </Bullet>
                <Bullet>
                  <Text theme={themeDefault} className={AccordionParagraph}>
                    Singlife CareShield Standard/Singlife CareShield Plus can be
                    purchased by CareShield Life (CSHL) or ElderShield (ESH)
                    policyholders.
                  </Text>
                </Bullet>
                <Bullet>
                  <Text theme={themeDefault} className={AccordionParagraph}>
                    You need to have a basic CareShield Life (CSHL) or
                    ElderShield (ESH) policy before purchasing MyLongTermCare or
                    MyLongTermCare Plus (“Supplements”) Supplements purchased by
                    CSHL policyholders are regulated under the CareShield Life
                    and Long-term Care Act. Supplements purchased by ESH
                    policyholders before the transfer of ESH to Government
                    administration are considered ESH Supplements, which are
                    regulated under the Central Provident Fund (Withdrawals for
                    ElderShield Scheme) Regulations. After the transfer, they
                    are considered CSHL Supplements, regulated under the
                    CareShield Life and Long-Term Care Act.
                  </Text>
                </Bullet>
                <Bullet>
                  <Text theme={themeDefault} className={AccordionParagraph}>
                    As this is a product with no financial advice, there is no
                    associated distribution costs in relation to the provision
                    of advice.
                  </Text>
                </Bullet>
                <Bullet>
                  <Text theme={themeDefault} className={AccordionParagraph}>
                    Singlife CareShield Standard and Singlife CareShield Plus
                    are also available via Singlife’s appointed distributors and
                    intermediaries. Product features offered and premiums are
                    the same irrespective of the purchase channel, i.e. buy
                    online here or via appointed financial adviser
                    representatives.{" "}
                  </Text>
                </Bullet>
                <Bullet>
                  <Text theme={themeDefault} className={AccordionParagraph}>
                    All Supplements are regulated under the CareShield Life and
                    Long-Term Care Act.
                  </Text>
                </Bullet>
                <Bullet>
                  <Text theme={themeDefault} className={AccordionParagraph}>
                    Anyone who pays for, or is insured under Singlife CareShield
                    Standard/ Singlife CareShield Plus (Supplement) is not
                    eligible for Additional Premium Support (APS) from the
                    Government*. If you are currently receiving APS to pay for
                    your MediShield and/ or CareShield Life premiums, and you
                    choose to be insured under this Supplement policy, you will
                    stop receiving APS. This applies even if you are not the
                    person paying for this Supplement policy. In addition, if
                    you choose to be insured under this Supplement policy, the
                    person paying for the Supplement will stop receiving APS, if
                    he or she is currently receiving APS.
                  </Text>
                </Bullet>
                <Bullet variant="nobullet">
                  <Text theme={themeDefault} className={AccordionParagraph}>
                    *APS is for families who need assistance with MediShield
                    Life and/or CareShield Life premiums, even after receiving
                    premium subsidies and making use of MediSave to pay for
                    these premiums.
                  </Text>
                </Bullet>
              </div>
            </Accordion>
          </AccordionContainer>
        </FormContainer>
      )}

      <Stepper steps={stepsList}></Stepper>

      <ModalContainer className="ModalContainer" ref={modalContainerRef}>
        <div style={{ opacity: 0, position: "absolute" }}>
          <Tooltip maxWidth={588} theme={themeDefault}>
            <PlanTermTooltipContainer>
              <h4>This plan covers you for your lifetime</h4>
              <PlanTermTooltipListing>
                {toolTipData.map((toolTip) => (
                  <TootipListingItem>{toolTip}</TootipListingItem>
                ))}
              </PlanTermTooltipListing>
            </PlanTermTooltipContainer>
          </Tooltip>
        </div>
        <div style={{ opacity: 0, position: "absolute" }}>
          <Tooltip maxWidth={588} theme={themeDefault}>
            <PayoutTooltipContainer>
              <h4>What is CareShield Life payout?</h4>
              <p>
                This is the monthly payout you'll receive should you suffer from
                a severe disability.
              </p>
            </PayoutTooltipContainer>
          </Tooltip>
        </div>
      </ModalContainer>

      <MobileModalContainer>
        <BottomSheetDrag
          overlayClick={() => hideModal(1, "click")}
          ref={bottomSheet1}
          isShow={false}
        >
          <TooltipBottomSheet theme={themeDefault}>
            <PlanTermTooltipContainer>
              <h4>This plan covers you for your lifetime</h4>
              <PlanTermTooltipListing>
                {toolTipData.map((toolTip) => (
                  <TootipListingItem>{toolTip}</TootipListingItem>
                ))}
              </PlanTermTooltipListing>
            </PlanTermTooltipContainer>
          </TooltipBottomSheet>
        </BottomSheetDrag>
        <BottomSheetDrag
          overlayClick={() => hideModal(2, "click")}
          ref={bottomSheet2}
          isShow={false}
        >
          <TooltipBottomSheet theme={themeDefault}>
            <PayoutTooltipContainer>
              <h4>What is CareShield Life payout?</h4>
              <p>
                This is the monthly payout you'll receive should you suffer from
                a severe disability.
              </p>
            </PayoutTooltipContainer>
          </TooltipBottomSheet>
        </BottomSheetDrag>
      </MobileModalContainer>

      <BottomSheet />

      <QRLTCMaxCoverageModal
        show={showQRLTCMaxCoverageModal}
        onClose={() => setShowQRLTCMaxCoverageModal(false)}
        className={customModalCss}
      >
        <img className={imgCss} src={successTickIcon} alt="icon-img" />
        <div className={maxModalTitle}>Maximum Coverage Reached</div>
        <div className={maxModalDesc}>
          Your current coverage has reached the maximum available amount of S$5,000 per month, providing strong protection against future care costs.
        </div>
        <div className={buttonContainerCss}>
          <Button label="Okay" width="160px" onClick={onHandleMaxCoverage} />
        </div>
      </QRLTCMaxCoverageModal>

      <PromoCodeModal
        onClose={() => {
          setIsPromoCodeVisible(false);
          if (requirePromoNric && (values["promoNric"] === "" || !validNric)) {
            resetCheck();
            onCheckPromoCode(true);
          }
          // setTimeout(() => {
          //   setPromoCodeStatus("");
          // }, 500);
        }}
        show={isPromoCodeVisible}
      >
        <PromoCodeContent
          value={values["promoCode"]}
          isApplied={appliedPromoCode}
          nricRequired={requirePromoNric}
          promoCodeStatus={promoCodeStatus}
          nricMsgCode={nricMsgCodeStatus}
          promoMsgCode={promoMsgCodeStatus}
          show={isPromoCodeVisible}
          onChange={(e) => {
            onChange(e);
          }}
          validatePromoCode={(promoCode) => {
            onCheckPromoCode();
          }}
          validateNric={(nric) => {
            onCheckPromoNric();
          }}
        />
      </PromoCodeModal>
    </Container>
  );
};

export default ChoosePlan;

//TODO: Modal popup for promocode
//TODO: use hovering for tooltip
const quoteInitialSample = [
  {
    name: "",
    type: "basic",
    details: [
      { text: "Plan", value: "-" },
      { text: "Monthly benefit payout", value: "-" },
      { text: "Plan&nbsp;structure", value: "-" },
      { text: "Policy term", value: "-" },
      { text: "Premium&nbsp;term", value: "-" },
      { text: "Premium amount", value: "-" },
      { text: "Promo code", value: "-" },
    ],
  },
];

const summarizationSources = [
  {
    heading: { text: "Plan Overview" },
    descriptions: [
      { text: "Plan Selected", value: "-" },
      { text: "Monthly Benefit", value: "-" },
    ],
  },
  {
    heading: { text: "Premium Breakdown" },
    descriptions: [
      { text: "Annual Premium", value: "-" },
      {
        text: 'Promo Code: <a class="insertPromoCodeClass">Edit</a>',
        value: "-",
      },
      { text: "LTC1 (20% off applied)" },
      // { text: 'Annual Premium (after discount)', value: '-'},
    ],
  },
];

const summarizationSummarySources = {
  text: "Cash Payment",
  subtext: "(Based on the CPF MediSave deduction of up to S$600)",
  value: "-",
};

const planOptions = {
  options: [
    {
      value: "MLTC",
      description: `Singlife CareShield Standard`,
      key: "myCareEnhanced",
    },
    {
      value: "MLTCP",
      description: `Singlife CareShield Plus`,
      key: "myCarePlusEnhanced",
    },
  ],
};
const planStructureOptions = {
  options: [
    {
      value: "LEVEL",
      description: `I prefer fixed structure - same payout, same premium every year`,
      key: "level",
    },
    {
      value: "ESCALATING_2_PERCENT",
      description: `I prefer increasing payout and premium at 2% per year`,
      key: "2",
    },
    {
      value: "ESCALATING_3_PERCENT",
      description: `I prefer increasing payout and premium at 3% per year`,
      key: "3",
    },
  ],
};
const premiumTermOptions = {
  options: [
    {
      value: "OPTION_LIMITED",
      terms: "0",
      description: "For 0 years, until I'm 69 Age Next Birthday",
      age: 0,
      key: "limited",
    },
    {
      value: "OPTION_LIFETIME",
      terms: "0",
      description: "For 0 years, until I'm 99 Age Next Birthday",
      age: 0,
      key: "lifetime",
    },
  ],
};

const dataMockSqs = {
  loginId: "QnB",
  firmClntnum: "test",
  sourceOfBusiness: "test",
  proposalType: "LA",
  tables: null,
  coverages: [
    {
      id: "myCarePlusEnhanced",
      type: "P",
      name: "MyLongTermCare Plus",
      productClass: "health",
      coverageClass: null,
      premiumType: "RP",
      mode: "RP",
      productCode: "CQG",
      code: "EYB",
      riderType: "test",
      addType: "P",
      attributes: {
        code: "test",
        riderType: "test",
        planPremiumMode: "AP",
        currency: "SGD",
        monthlyBenefit: "2000",
        premiumTerm: "lifetime",
        benefitPayoutDuration: "lifetime",
        premiumTermYears: 28,
        escBenefit: "2",
        promoCodeSummary: "CUS1",
        policyTerm: 58,
        modalPremiumNoGST: 1620,
        modalPremium: 173.4,
        annualPremium: "1733.40",
        componentCode: "ENUJ,ZTAE,ZTPW,ZHP5",
        mortalityClass: "N",
        promoCode: "LTC1", //LTC1
        discountEligible: true,
        firstYrDiscountEligible: true,
        discountedPremium: {
          modalPremiumNoGST: 1296,
          modalPremium: 1386.72,
          annualPremium: "1386.72",
          staffDiscount: 20,
          promoCode: "LTC1", //LTC1
          staffIndicator: "I",
          firstYrModalPremiumNoGST: 2006,
          firstYrModalPremium: 214.42,
          firstYrAnnualPremium: "2146.42",
          firstYrDisc: 15,
          firstYrDiscType: "dollar",
          firstYrDiscAmnt: 378.78,
          additionalChecks: null, //"Y",
          hideDiscounts: false,
        },
        sumAssured: 0,
      },
    },
  ],
  lifeProfiles: [
    {
      name: "Test Name",
      gender: "M",
      smoker: "N",
      dob: "28021989",
      age: 32,
      occupationName: "Abattoir Worker",
      occupationCode: "A416",
      relationshipName: "test",
      relationshipId: "test",
      type: "life-assured",
      riskClass: "CLS4",
    },
  ],
  errors: null,
  sqsVersion: "sqs v",
  infos: null,
  modalPremium: 2525.2,
  modalPremiumNoGST: 2360,
  firstYrModalPremium: 2146.42,
  firstYrModalPremiumNoGST: 2006,
  staffIndicator: "A",
  staffDiscount: 20,
  firstYrDisc: 15,
  firstYrDiscType: "percent",
  firstYrDiscAmnt: 378.78,
  additionalChecks: "Y",
  bistacking: false,
};

const promoAlertGreen = css`
  color: #0a544f;
`;

const computeQuoteMocks = {
  error: "",
  data: {
    loginId: "QnB",
    firmClntnum: "",
    sourceOfBusiness: "",
    proposalType: "LA",
    tables: [],
    coverages: [
      {
        id: "myCareEnhanced",
        type: "P",
        name: "Singlife CareShield Standard",
        productClass: "health",
        coverageClass: null,
        premiumType: "RP",
        mode: "RP",
        productCode: "EYA",
        code: "EYA",
        riderType: "",
        addType: "",
        attributes: {
          code: "",
          riderType: "",
          planPremiumMode: "AP",
          currency: "SGD",
          monthlyBenefit: "1000",
          premiumTerm: "limited",
          benefitPayoutDuration: "lifetime",
          premiumTermYears: 27,
          escBenefit: "level",
          promoCodeSummary: "",
          policyTerm: 57,
          modalPremiumNoGST: 944.0,
          modalPremium: 1010.08,
          annualPremium: "1010.08",
          componentCode: "HNYA,ZDP1,ZDP2,HPRD",
          mortalityClass: "N",
          promoCode: "LTC1",
          discountEligible: true,
          firstYrDiscountEligible: false,
          discountedPremium: {
            modalPremiumNoGST: 755.2,
            modalPremium: 808.06,
            annualPremium: "808.06",
            staffDiscount: 20,
            promoCode: "LTC1",
            staffIndicator: "I",
            firstYrModalPremiumNoGST: 0.0,
            firstYrModalPremium: 0.0,
            firstYrAnnualPremium: null,
            firstYrDisc: 0.0,
            firstYrDiscType: null,
            firstYrDiscAmnt: 0.0,
            additionalChecks: null,
            hideDiscounts: false,
          },
          sumAssured: 0.0,
        },
      },
    ],
    lifeProfiles: [
      {
        name: "",
        gender: "Male",
        smoker: "Non-Smoker",
        dob: "02041981",
        age: 42,
        occupationName: "",
        occupationCode: null,
        relationshipName: "",
        relationshipId: "",
        type: "life-assured",
        riskClass: null,
      },
    ],
    errors: [],
    sqsVersion: "SG.FA.2.1.1.25",
    infos: null,
    bistacking: false,
  },
};
